const normalizeCategorySlug = (category: string | undefined): string => {
  if (!category) return '';

  return category.trim().toLowerCase().replace(/\s+/g, '-');
};

export default normalizeCategorySlug;
